import React, { useState } from "react";
import { useGame } from "@/contexts/GameContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Plus, X, UserCheck } from "lucide-react";
import { suggestedNames } from "@/lib/constants";

export default function PlayersStep() {
  const { state, dispatch } = useGame();
  const [newPlayerName, setNewPlayerName] = useState("");

  console.log(
    "👥 PlayersStep - Aktualna lista graczy:",
    state.players.map((p) => p.name)
  );

  const addPlayer = () => {
    if (
      newPlayerName.trim() &&
      !state.players.find((p) => p.name === newPlayerName.trim())
    ) {
      console.log("➕ Dodawanie nowego gracza:", newPlayerName.trim());
      dispatch({ type: "ADD_PLAYER", payload: newPlayerName.trim() });
      setNewPlayerName("");
    } else {
      console.log("⚠️ Nie można dodać gracza:", {
        isEmpty: !newPlayerName.trim(),
        alreadyExists: state.players.find(
          (p) => p.name === newPlayerName.trim()
        ),
      });
    }
  };

  const removePlayer = (playerId) => {
    const player = state.players.find((p) => p.id === playerId);
    console.log("🗑️ Usuwanie gracza:", player?.name, playerId);
    dispatch({ type: "REMOVE_PLAYER", payload: playerId });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addPlayer();
    }
  };

  return (
    <div className="space-y-4">
      {/* Input do dodawania gracza - zmniejszony */}
      <div className="flex items-center gap-2 bg-background backdrop-blur-sm p-1.5 rounded-full border shadow-sm">
        <Input
          placeholder="Imię gracza..."
          value={newPlayerName}
          onChange={(e) => setNewPlayerName(e.target.value)}
          onKeyPress={handleKeyPress}
          className="flex-1 h-10 text-base rounded-full border-none bg-transparent shadow-none focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0"
        />
        <Button
          onClick={addPlayer}
          disabled={!newPlayerName.trim()}
          size="icon"
          className="rounded-full"
        >
          <Plus className="w-4 h-4" />
        </Button>
      </div>

      <div className="mb-4">
        <p className="text-sm text-center text-muted-foreground mb-2">
          lub wybierz z sugestii:
        </p>
        <div className="flex flex-wrap justify-center gap-1">
          {suggestedNames.map((name) => (
            <Button
              key={name}
              variant="secondary"
              size="sm"
              onClick={() => setNewPlayerName(name)}
              className="h-8 text-xs"
            >
              {name}
            </Button>
          ))}
        </div>
      </div>

      {/* Lista Graczy - zmniejszona */}
      {state.players.length > 0 && (
        <div className="flex flex-wrap gap-2 items-center justify-center pt-2">
          {state.players.map((player) => (
            <div
              key={player.id}
              className="relative flex gap-2 items-center justify-between bg-card p-2 rounded-full shadow-sm border border-border transition-all"
            >
              <div className="flex items-center gap-3">
                <Avatar className="w-8 h-8 border-2 border-white/20">
                  <AvatarFallback className="bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold text-sm">
                    {player.name.charAt(0).toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <span className="font-semibold text-sm">{player.name}</span>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => removePlayer(player.id)}
                className=" -top-3 -right-3  hover:text-red-500 hover:bg-red-500/10 rounded-full w-6 h-6"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}

      {/* Informacja - zmniejszona */}
      {state.players.length < 2 && (
        <div className="text-center text-sm p-3 rounded-xl border flex items-center justify-center gap-2">
          <UserCheck className="w-4 h-4" />
          <span>Potrzebujesz jeszcze {2 - state.players.length} gracza!</span>
        </div>
      )}
    </div>
  );
}
